/* ============================================================================
   HUB SUNSET SESSIONS — behaviour for sections/hub-sunset-sessions.liquid.

   1. Every [data-ss-sky] is coloured from the sun's REAL altitude over the
      venue at its data-time (HH:MM, Singapore time, on the event's date).
   2. The programme's sky ([data-ss-live]) follows the scroll: the time is
      read off the step that sits under a reading line, so the sun sinks to
      where it will actually be when you get to that part of the evening.
   3. Countdown line, sunset time, calendar links, share.

   The solar position is the standard low-precision almanac formula (good to
   about a minute). Checked 2026-10-29 against the US Naval Observatory for
   1.2823 N 103.8527 E on 14 Nov 2026: sunset 18:51 SGT here and there.
   No dependencies. Everything degrades to the server-rendered page.
   ============================================================================ */
(function () {
  'use strict';
  var root = document.querySelector('[data-ss]');
  if (!root) return;

  var RAD = Math.PI / 180;
  var lat = parseFloat(root.getAttribute('data-lat')) || 1.2823;
  var lon = parseFloat(root.getAttribute('data-lon')) || 103.8527;
  var startISO = root.getAttribute('data-start') || '2026-11-14T16:30:00+08:00';
  var endISO = root.getAttribute('data-end') || '2026-11-14T19:30:00+08:00';
  var day = startISO.slice(0, 10);
  var startMs = Date.parse(startISO), endMs = Date.parse(endISO);

  /* ---------------------------------------------------------------- sun */
  function sunAlt(ms) {
    var n = ms / 86400000 + 2440587.5 - 2451545.0;
    var L = (280.460 + 0.9856474 * n) % 360;
    var g = ((357.528 + 0.9856003 * n) % 360) * RAD;
    var lam = (L + 1.915 * Math.sin(g) + 0.020 * Math.sin(2 * g)) * RAD;
    var eps = (23.439 - 0.0000004 * n) * RAD;
    var ra = Math.atan2(Math.cos(eps) * Math.sin(lam), Math.cos(lam));
    var dec = Math.asin(Math.sin(eps) * Math.sin(lam));
    var gmst = (18.697374558 + 24.06570982441908 * n) % 24;
    var ha = ((gmst * 15 + lon) % 360) * RAD - ra;
    var la = lat * RAD;
    return Math.asin(Math.sin(la) * Math.sin(dec) + Math.cos(la) * Math.cos(dec) * Math.cos(ha)) / RAD;
  }
  function msAt(min) { // minutes after midnight, Singapore (fixed UTC+8) -> epoch ms
    var h = Math.floor(min / 60), m = Math.round(min % 60);
    return Date.parse(day + 'T' + pad(h) + ':' + pad(m) + ':00+08:00');
  }
  function pad(x) { return (x < 10 ? '0' : '') + x; }
  function hhmm(s) { var p = String(s || '').split(':'); return (+p[0] || 0) * 60 + (+p[1] || 0); }
  function label(min) {
    var h = Math.floor(min / 60), m = Math.floor(min % 60);
    return ((h + 11) % 12 + 1) + ':' + pad(m) + (h < 12 ? ' AM' : ' PM');
  }

  /* Sunset = the minute the sun's centre passes -0.833 deg (refraction + radius), searched across the evening. */
  var sunsetMin = null;
  for (var mm = 16 * 60, prev = sunAlt(msAt(mm)); mm < 21 * 60; mm++) {
    var a = sunAlt(msAt(mm + 1));
    if (prev > -0.833 && a <= -0.833) { sunsetMin = mm + 1; break; }
    prev = a;
  }
  if (sunsetMin) {
    var sl = root.querySelectorAll('[data-ss-sunset]');
    for (var i = 0; i < sl.length; i++) sl[i].textContent = label(sunsetMin);
  }

  /* ---------------------------------------------------------------- sky palette by altitude */
  var K = [
    { a: 40,   top: '#1c3a7a', mid: '#5b86c6', hz: '#f4d9a0', wtop: '#3e5f8f', water: '#1a2c4f', core: '#fffbea', edge: '#fff0c2', glow: [255, 236, 180, .42] },
    { a: 24,   top: '#1b2f6b', mid: '#6d78b8', hz: '#f8c27a', wtop: '#4a5684', water: '#1c2647', core: '#fff3d0', edge: '#ffd98a', glow: [255, 205, 120, .5] },
    { a: 12,   top: '#1a2560', mid: '#8a6aa6', hz: '#ffa65a', wtop: '#5a4a78', water: '#1e2042', core: '#ffe6a6', edge: '#ffb55c', glow: [255, 165, 80, .58] },
    { a: 4,    top: '#161d4e', mid: '#a05a86', hz: '#ff7f3f', wtop: '#5e3e66', water: '#1c1b3a', core: '#ffd38a', edge: '#ff8f45', glow: [255, 128, 60, .66] },
    { a: 0,    top: '#131846', mid: '#9e4a78', hz: '#ff6235', wtop: '#5a3358', water: '#1a1834', core: '#ffb070', edge: '#ff6d3a', glow: [255, 100, 55, .7] },
    { a: -2.5, top: '#10153c', mid: '#7a3e70', hz: '#f0546a', wtop: '#46294c', water: '#16152e', core: '#ff8a5a', edge: '#ff5a3a', glow: [240, 84, 100, .45] },
    { a: -6,   top: '#0d1130', mid: '#3e2c66', hz: '#9a4f86', wtop: '#2a2142', water: '#111226', core: '#ff7a5a', edge: '#ff5a3a', glow: [160, 80, 140, .25] },
    { a: -10,  top: '#0b0e22', mid: '#1d2148', hz: '#4a3c6e', wtop: '#1a1a32', water: '#0d0f1e', core: '#ff7a5a', edge: '#ff5a3a', glow: [90, 70, 140, .12] },
    { a: -14,  top: '#0a0d16', mid: '#121733', hz: '#252845', wtop: '#14152a', water: '#0b0d18', core: '#ff7a5a', edge: '#ff5a3a', glow: [60, 60, 110, .05] }
  ];
  function hex(h) { return [parseInt(h.substr(1, 2), 16), parseInt(h.substr(3, 2), 16), parseInt(h.substr(5, 2), 16)]; }
  function mix(c1, c2, t) { var a = hex(c1), b = hex(c2); return 'rgb(' + Math.round(a[0] + (b[0] - a[0]) * t) + ',' + Math.round(a[1] + (b[1] - a[1]) * t) + ',' + Math.round(a[2] + (b[2] - a[2]) * t) + ')'; }
  function mixA(a, b, t) { return 'rgba(' + Math.round(a[0] + (b[0] - a[0]) * t) + ',' + Math.round(a[1] + (b[1] - a[1]) * t) + ',' + Math.round(a[2] + (b[2] - a[2]) * t) + ',' + (a[3] + (b[3] - a[3]) * t).toFixed(3) + ')'; }
  function clamp(x, lo, hi) { return x < lo ? lo : x > hi ? hi : x; }
  function ramp(x, x0, x1, y0, y1) { return y0 + (y1 - y0) * clamp((x - x0) / (x1 - x0), 0, 1); }

  function paint(sky, alt) {
    var j = 0;
    while (j < K.length - 2 && alt < K[j + 1].a) j++;
    var A = K[j], B = K[j + 1], t = clamp((A.a - alt) / (A.a - B.a), 0, 1);
    var st = sky.style;
    ['top', 'mid', 'hz', 'wtop', 'water'].forEach(function (k) { st.setProperty('--sk-' + k, mix(A[k], B[k], t)); });
    st.setProperty('--sun-core', mix(A.core, B.core, t));
    st.setProperty('--sun-edge', mix(A.edge, B.edge, t));
    st.setProperty('--sun-glow', mixA(A.glow, B.glow, t));
    var hz = sky._hz || (sky._hz = parseFloat(getComputedStyle(sky).getPropertyValue('--hz')) || 60);
    var grow = 1 + .22 * ramp(alt, 20, 0, 0, 1);
    var dPx = clamp((window.innerWidth || 1200) * .16, 90, 210) * grow;      // same as the CSS clamp below
    var r = dPx / 2 / Math.max(1, sky.clientHeight || 600) * 100;            // sun radius, % of the sky's height
    /* The disc is drawn far bigger than the real sun, so its height is mapped, not scaled: the top edge meets the
       water at true sunset (-0.833 deg, the almanac's definition), the disc clears the water 4 deg above that,
       and ~31 deg up sits near the top of the frame. The water layer hides whatever is below the horizon. */
    var v = alt + 0.833, y;
    if (v <= 0) y = hz + r + Math.min(-v, 10) * r;
    else if (v <= 4) y = hz + r - (v / 4) * 2 * r;
    else y = hz - r - clamp((v - 4) / 27, 0, 1) * Math.max(0, hz - r - 12);
    st.setProperty('--sun-y', y.toFixed(2) + '%');
    st.setProperty('--glint-a', (alt >= 0 ? ramp(alt, 30, 2, .22, .95) : ramp(alt, 0, -4, .9, 0)).toFixed(3));
    st.setProperty('--stars', ramp(alt, -4, -11, 0, 1).toFixed(3));
    st.setProperty('--sun-d', 'calc(clamp(90px, 16vw, 210px) * ' + grow.toFixed(3) + ')');
  }

  var skies = root.querySelectorAll('[data-ss-sky]');
  for (var k = 0; k < skies.length; k++) {
    var sx = skies[k].getAttribute('data-sun-x');
    if (sx) skies[k].style.setProperty('--sun-x', sx + '%');
    if (!skies[k].hasAttribute('data-ss-live')) paint(skies[k], sunAlt(msAt(hhmm(skies[k].getAttribute('data-time')))));
  }

  /* Hero: put the horizon in the gap between the two title lines. offsetTop ignores the entrance transform. */
  var hero = root.querySelector('.ss-hero'), heroSky = hero && hero.querySelector('[data-ss-sky]');
  var line1 = hero && hero.querySelector('.ss-hero__title span'), inner = hero && hero.querySelector('.ss-hero__inner');
  function alignHorizon() {
    if (!heroSky || !line1 || !inner || !hero.offsetHeight) return;
    var pct = (inner.offsetTop + line1.offsetTop + line1.offsetHeight) / hero.offsetHeight * 100;
    if (pct < 20 || pct > 88) return;
    heroSky.style.setProperty('--hz', pct.toFixed(2) + '%');
    heroSky._hz = pct;
    paint(heroSky, sunAlt(msAt(hhmm(heroSky.getAttribute('data-time')))));
  }
  alignHorizon();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(alignHorizon);

  /* ---------------------------------------------------------------- scroll-driven programme */
  var live = root.querySelector('[data-ss-live]');
  var stage = root.querySelector('.ss-prog__stage');
  var steps = [].slice.call(root.querySelectorAll('[data-ss-step]'));
  var clock = root.querySelector('[data-ss-clock]');
  var altEl = root.querySelector('[data-ss-alt]');
  var fill = root.querySelector('[data-ss-fill]');
  var setMark = root.querySelector('[data-ss-setmark]');
  var times = steps.map(function (el) { return hhmm(el.getAttribute('data-t')); });
  var t0 = times[0] || 990, t1 = times[times.length - 1] || 1170;
  if (setMark && sunsetMin && t1 > t0) setMark.style.setProperty('--setp', clamp((sunsetMin - t0) / (t1 - t0) * 100, 0, 100) + '%');
  root.classList.add('is-live');

  var lastMin = -1, lastOn = -1, queued = false;
  function phrase(alt) {
    if (alt >= 0.5) return 'Sun ' + Math.round(alt) + '° above the horizon';
    if (alt > -0.9) return 'Sunset';
    if (alt > -6) return 'Afterglow';
    return 'Blue hour';
  }
  function update() {
    queued = false;
    if (!live || !steps.length) return;
    var vh = window.innerHeight || 800;
    var stageH = stage ? stage.getBoundingClientRect().height : 0;
    var wide = stageH > vh * .7;                       // desktop: stage is a full-height column
    var line = wide ? vh * .5 : stageH + (vh - stageH) * .38;
    var on = 0, min = times[0];
    for (var i = 0; i < steps.length; i++) {
      var top = steps[i].getBoundingClientRect().top;
      if (top <= line) {
        on = i;
        if (i < steps.length - 1) {
          var next = steps[i + 1].getBoundingClientRect().top;
          var p = clamp((line - top) / Math.max(1, next - top), 0, 1);
          min = times[i] + (times[i + 1] - times[i]) * p;
        } else {
          min = times[i];
        }
      }
    }
    if (on !== lastOn) {
      if (steps[lastOn]) steps[lastOn].classList.remove('is-on');
      steps[on].classList.add('is-on');
      lastOn = on;
    }
    if (Math.abs(min - lastMin) < 0.2) return;
    lastMin = min;
    var alt = sunAlt(msAt(min));
    paint(live, alt);
    if (clock) clock.textContent = label(min);
    if (altEl) altEl.textContent = phrase(alt);
    if (fill && t1 > t0) fill.style.setProperty('--p', clamp((min - t0) / (t1 - t0) * 100, 0, 100) + '%');
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(update); } }
  update();                                            // first paint without waiting for a frame (a hidden tab gets none)
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', function () { if (live) live._hz = 0; lastMin = -1; alignHorizon(); queue(); });

  /* ---------------------------------------------------------------- countdown line */
  function sgtDate(ms) { return new Date(ms + 8 * 3600000).toISOString().slice(0, 10); }
  function countdown() {
    var now = Date.now(), note = root.querySelectorAll('[data-ss-count]'), txt;
    var days = Math.round((Date.parse(day) - Date.parse(sgtDate(now))) / 86400000);
    if (now >= endMs) {
      txt = 'That was Sunset Sessions. Thank you for coming';
      var forms = root.querySelectorAll('[data-ss-form]');
      for (var f = 0; f < forms.length; f++) forms[f].hidden = true;
    } else if (now >= startMs) txt = 'Happening now at Harry’s';
    else if (days <= 0) txt = 'Free · Today, ' + label(hhmm(startISO.slice(11, 16)));
    else if (days === 1) txt = 'Free · Tomorrow';
    else txt = 'Free · ' + days + ' days to go';
    for (var n = 0; n < note.length; n++) note[n].textContent = txt;
  }
  countdown();

  /* ---------------------------------------------------------------- calendar + share */
  var title = root.getAttribute('data-title') || 'Sunset Sessions';
  var venue = root.getAttribute('data-venue') || '';
  var pageUrl = root.getAttribute('data-url') || location.href.split('#')[0];
  var formUrl = root.getAttribute('data-form') || pageUrl;
  // '#register' = the sign-up form on this page; a calendar entry needs the full link.
  if (formUrl.charAt(0) === '#') formUrl = pageUrl + formUrl;
  var details = 'Social run around Marina Bay, then drinks at Harry’s.\nReserve your spot: ' + formUrl + '\nDetails: ' + pageUrl;
  function utc(ms) { return new Date(ms).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); }

  var g = root.querySelector('[data-ss-gcal]');
  if (g) g.href = 'https://calendar.google.com/calendar/render?action=TEMPLATE'
    + '&text=' + encodeURIComponent(title) + '&dates=' + utc(startMs) + '/' + utc(endMs)
    + '&details=' + encodeURIComponent(details) + '&location=' + encodeURIComponent(venue);

  function esc(s) { return String(s).replace(/\\/g, '\\\\').replace(/([,;])/g, '\\$1').replace(/\n/g, '\\n'); }
  var ics = root.querySelector('[data-ss-ics]');
  if (ics) ics.addEventListener('click', function () {
    var body = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//ATHLO+//Sunset Sessions//EN', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH',
      'BEGIN:VEVENT', 'UID:sunset-sessions-' + day + '@athlo.sg', 'DTSTAMP:' + utc(Date.now()),
      'DTSTART:' + utc(startMs), 'DTEND:' + utc(endMs), 'SUMMARY:' + esc(title), 'LOCATION:' + esc(venue),
      'DESCRIPTION:' + esc(details), 'URL:' + pageUrl, 'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
    var a = document.createElement('a');
    a.href = 'data:text/calendar;charset=utf-8,' + encodeURIComponent(body);
    a.download = 'sunset-sessions.ics';
    document.body.appendChild(a); a.click(); a.remove();
    track('calendar', 'ics');
  });
  if (g) g.addEventListener('click', function () { track('calendar', 'google'); });

  var share = root.querySelector('[data-ss-share]');
  if (share) share.addEventListener('click', function () {
    var data = { title: title, text: 'Sunset run along Marina Bay, then drinks at Harry’s. Sat 14 Nov, 4:30 PM.', url: pageUrl };
    track('share', navigator.share ? 'native' : 'copy');
    if (navigator.share) { navigator.share(data).catch(function () {}); return; }
    var done = function () { var t = share.textContent; share.textContent = 'Link copied'; setTimeout(function () { share.textContent = t; }, 2200); };
    if (navigator.clipboard) navigator.clipboard.writeText(pageUrl).then(done, function () {});
  });

  var forms2 = root.querySelectorAll('[data-ss-form]');
  for (var q = 0; q < forms2.length; q++) {
    forms2[q].addEventListener('click', function (e) {
      track('reserve', e.currentTarget.closest('.ss-end') ? 'closing' : 'hero');
    });
  }
  /* Once this browser has a place (hub-event-signup.js, remember_me), both Reserve
     buttons say so, and a tap opens the code instead of an empty form. */
  function going(on, lbl) {
    for (var i = 0; i < forms2.length; i++) {
      var a = forms2[i], t = a.firstChild, arrow = a.querySelector('.ss-btn__arrow');
      if (!t || t.nodeType !== 3) continue;
      if (a._ssLbl === undefined) { a._ssLbl = t.nodeValue; a._ssArrow = arrow ? arrow.textContent : ''; }
      t.nodeValue = on && lbl ? lbl : a._ssLbl;
      if (arrow) arrow.textContent = on ? '✓' : a._ssArrow;
      a.classList.toggle('is-going', !!on);
    }
  }
  document.addEventListener('athlo:event-going', function (e) {
    var d = e.detail || {};
    going(d.going, d.label);
  });
  var R = document.documentElement;
  if (R.classList.contains('es-going')) going(true, R.getAttribute('data-es-going-label'));

  function track(action, placement) {
    try { if (typeof window.gtag === 'function') window.gtag('event', 'event_page_' + action, { event_slug: 'sunset-sessions', placement: placement }); } catch (e) {}
  }
})();
